module.exports = __webpack_public_path__ + "assets/img/jiagou2.b92257ad.svg";